<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <LayoutTheHeader
      is-template4
      :route-path="routePath"
      @open-login="openLogin"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main :class="{ 'pt-[3.75rem]': !isHome }">
      <slot />
    </main>
    <LazyLayoutTheFooterTwoFive />
    <slot name="whats-app">
      <LazyLayoutWhatsappFloatButtonPicker :raised="isProductPage" />
    </slot>
  </Html>
</template>

<script setup lang="ts">
const authRef = ref<any>(null);
function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const head = useI18nHead();

const localePath = useLocalePath();

const route = useRoute();
const routePath = ref(route.path);
const isProductPage = useIsProductPage();

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true }
);
</script>
